export default __webpack_public_path__ + "static/media/trueTickMark.34d4e4d0.svg";